import {ContinueButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {gsap} from "gsap";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {Loner} from "../../Loner";
import {LonerBitmapCountUp} from "../../components/LonerBitmapCountUp";
import {NLCText} from "@nolimitcity/slot-launcher/bin/display/NLCText";

/**
 * Class description
 *
 * Created: 2021-11-18
 * @author jonas
 */
export class LonerOutroView extends PIXI.Container implements StageLayer {

    protected _button: ContinueButton;
    protected _outroContainer: PIXI.Container;
    protected _clickCallback: Function;
    protected _countUp: LonerBitmapCountUp;
    protected _betMultipliedText: PIXI.Text;

    constructor() {
        super();
        this.init();
    }

    protected getOutroContent(): PIXI.Container {
        return new PIXI.Container();
    }

    protected init(): void {
        this._outroContainer = this.getOutroContent();
        this._outroContainer.alpha = 0;
        this.addChild(this._outroContainer);

        this._button = new ContinueButton();
        this._button.addClickCallback(() => this.onButtonClick());
        this._button.position.set(360, 615);
        this._button.pivot.set(this._button.width * 0.5, this._button.height * 0.5);
        this._button.enable(false);
        this._button.alpha = 0;

        this._countUp = new LonerBitmapCountUp(70, 580);
        this._countUp.scale.set(0.8, 0.8);
        this._countUp.stopAt(0);
        this._countUp.position.set(360, this.getCountUpYPos());
        this._countUp.alpha = 0;

        this._outroContainer.addChild(this._countUp);
        this._outroContainer.position = this.getOutroContainerPos();
        this.addChild(this._outroContainer);

        this.addChild(this._button);

        this.visible = false;

        this.onResize();
    }

    protected onButtonClick(): void {
        this._button.enable(false);
        this._clickCallback();
    }

    public hideOutro(isWinBelowStake: boolean): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            Loner.allReelView.visible = true;
        });
        tl.add([
            gsap.to(this._outroContainer, {duration: 1.0, alpha: 0}),
            gsap.to(this._button, {duration: 0.4, alpha: 0})
        ]);
        tl.add(() => {
            this._countUp.alpha = 0;
            this._countUp.stopAt(0);
        });
        tl.add(() => {
            this.visible = false;
        });
        return tl;
    }

    onResize(): void {
        const bounds: ScreenBounds = NolimitApplication.screenBounds;

        //Copied from Launcher/GameIntroView, so we get consistent placement of buttons
        if (NolimitApplication.isLandscape) {
            this._button.position.set(360, 615);
        } else {
            const centerBottom = (bounds.bottom - 610) * 0.5 + 610;
            this._button.position.set(360, centerBottom - 80);
        }
    }

    public showButton(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(() => this._button.enable(true));
        tl.add(gsap.to(this._button, {duration: 0.2, alpha: 1}));
        return tl;
    }

    public getCountUp(amount: number, countDuration: number = 2, isWinBelowStake: boolean): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        return tl;
    }

    public showOutro(callback: Function): gsap.core.Timeline {
        this._countUp.position.y = this.getCountUpYPos();
        this._clickCallback = callback;
        this.visible = true;
        const tl: gsap.core.Timeline = new gsap.core.Timeline();
        tl.add(() => this.onResize());
        tl.add(gsap.to(this._outroContainer, {duration: 0.6, alpha: 1}));
        tl.add(() => {
            this._countUp.alpha = 0
        });

        return tl;
    }

    protected getCountUpYPos() {
        return 170;
    }

    protected getOutroContainerPos(): PIXI.Point {
        return new PIXI.Point(0, 0);
    }
}